var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"non-hcp"},[_vm._v(" 帳號非HCP或權限有誤 ")])}
var staticRenderFns = []

export { render, staticRenderFns }